import { ResponseType } from 'axios';
import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import DialogCommon from '../../components/dialogCommon';
import InputCommon from '../../components/inputCommon';
import ItemListModal from '../../components/itemListModal';
import NavCommon from '../../components/navCommon';
import SelectComponentAutoComplete from '../../components/selectAutoCompleteCommon';
import TableCommon from '../../components/tableCommon';
import color from '../../constants/color';
import icons from '../../constants/icons';
import {
  PerfilDeAcesso,
  Regionais,
  UserPlatform,
  UserState,
  InterPrise,
} from '../../interfaces';
import API from '../../services/enterprise/index';
import API_USERS from '../../services/users';
import { LocaState } from '../../store/ducks/locais/types';
import SelectComponent from './component/select';
import {
  Img,
  LabelWithIcon,
  Row,
  RowCheck,
  RowCheckVisit,
  SelectContainer,
  SelectContainerRight,
  SizedBox,
} from './styles';

interface Corretor {
  idCorretor: string;
  nome: string;
  idRegional: string;
}

function AddUser() {
  const history = useHistory();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Array<UserPlatform>>([]);
  const [dataCopy, setDataCopy] = useState<Array<UserPlatform>>([]);
  const [name, setName] = useState<string | null>();
  const [lastName, setLastName] = useState<string | null>();
  const [email, setemail] = useState<string | null>();
  const [sigla, setSigla] = useState<string | null>();
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const [regionais, setRegionais] = useState<Array<Regionais>>();
  const [open, setOpen] = useState<boolean>(false);
  const [regionalSelect, setRegionalSelect] = useState<string>('');
  const [typeAcess, setTypeAcess] = useState<string>('');
  const [typeAcessName, setTypeAcessName] = useState<string>('');
  const [profileAcess, setProfileAcess] = useState<Array<PerfilDeAcesso>>([]);
  const [, setProfileAcessCopy] = useState<Array<PerfilDeAcesso>>([]);
  const [openAcess, setOpenAcess] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [idUser, setIdUser] = useState<string>('');
  const [locais, setLocais] = useState<Array<LocaState>>();
  const [localUser, setLocalUser] = useState<Array<LocaState>>();
  const [openLocal, setOpenLocal] = useState<boolean>(false);
  const [phone, setPhone] = useState<string>('');
  const [isSpecialista, setIsSpecialista] = useState(false);
  const [enterprises, setEnterprises] = useState<Array<InterPrise>>([]);
  const [isPlace, setIsPlace] = useState<boolean>(false);
  const [isLabel, setIsLabel] = useState<boolean>(false);
  const [loadingSave, setLoadingSave] = useState<boolean>(false);
  const [isVisit, setIsVisit] = useState<boolean>(false);
  const [receiveVisit, setReceiverVisit] = useState(false);
  const [corretores, setCorretores] = useState<Array<Corretor>>([]);
  const [corretor, setCorretor] = useState({
    corretor: { value: '', label: '' },
  });

  const { permissoes } = useSelector<RootStateOrAny, UserState>(
    (state) => state.user,
  );

  useEffect(() => {
    setLoading(true);
    enterpriseRequest();
    requestUsers();
    requestRegionais();
    requestAccessLevel();
    requestPlaces();
  }, []);

  useEffect(() => {
    if (regionalSelect) requestCorretores();
  }, [regionalSelect]);

  useEffect(() => {
    checkCondition();
  }, [typeAcess]);

  const checkCondition = () => {
    if (typeAcessName === 'Admin') {
      setIsPlace(true);
      setIsSpecialista(false);
      setIsLabel(true);
      setReceiverVisit(true);
    }
    if (typeAcessName === 'Especialista de Produto') {
      setIsPlace(false);
      setReceiverVisit(false);
      setIsSpecialista(true);
      setIsLabel(true);
    }
    if (typeAcessName === 'Corretor') {
      setIsLabel(true);
      setIsSpecialista(false);
      setIsPlace(true);
      setReceiverVisit(false);
    }
  };

  const enterpriseRequest = async () => {
    try {
      const response = await API.GetEnterprise();
      setEnterprises(response);
    } catch (error) {
      toast.error('Não foi possível obter a lista dos empreedimentos');
    }
  };

  const requestUsers = async () => {
    try {
      const response = await API_USERS.GetUsers();
      const { data: users } = response?.data;

      setData(users);
      setDataCopy(users);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const requestCorretores = async (): Promise<ResponseType> => {
    setCorretor({ corretor: { label: '', value: '' } });
    const response = await API_USERS.GetCorretor(regionalSelect);
    setCorretores(response.data.data);
    return response.data.data;
  };

  const requestCorretorById = async (id: string, idCorretor: string) => {
    const response = await API_USERS.GetCorretor(id);
    setCorretor({
      corretor: {
        label: response?.data?.data.filter(
          (item: any) => item?.idCorretor === idCorretor,
        )[0]?.nome,
        value: response?.data?.data.filter(
          (item: any) => item?.idCorretor === idCorretor,
        )[0]?.idCorretor,
      },
    });
  };

  const requestRegionais = async () => {
    try {
      const response = await API_USERS.GetRegionais();
      const regionaisData: Array<Regionais> = response?.data?.data;

      setRegionais(regionaisData);
    } catch (error) {
      toast.error('Não foi possível obter a lista das REGIONAIS');
    }
  };

  const requestAccessLevel = async () => {
    try {
      const response = await API_USERS.GetAccessLevel();
      const perfisAcessoData: Array<PerfilDeAcesso> = response?.data?.data;
      setProfileAcess(perfisAcessoData);
      setProfileAcessCopy(perfisAcessoData);
    } catch (error) {
      toast.error('Não foi possível obter a lista dos perfis de acesso!');
    }
  };

  const requestPlaces = async () => {
    try {
      const response = await API_USERS.GetPlaces();
      const { data: dataLocais } = response?.data;
      setLocais(dataLocais);
    } catch (error) {
      toast.error('Não foi possível obter os locais!');
    }
  };

  const handleChangeRegional = (event: any) => {
    setRegionalSelect(event.target.value);
  };

  const handleChangeAcess = (event: any) => {
    setTypeAcess(event.target.value);
    setTypeAcessName(
      profileAcess?.filter(
        (item) => item.idPerfilAcesso === event.target.value,
      )[0].nome,
    );
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const clearState = () => {
    setCorretor({ corretor: { value: '', label: '' } });
    setCorretores([]);
    setName('');
    setLastName('');
    setSigla('');
    setIsMobile(false);
    setIsAdmin(false);
    setRegionalSelect('');
    setTypeAcess('');
    setemail('');
    setPhone('');
    setLocalUser([]);
    setIsPlace(false);
    setTypeAcessName('');
    setIsEdit(false);
    setIsLabel(false);
    setReceiverVisit(false);
  };

  const handleCloseAcess = () => {
    setOpenAcess(false);
  };

  const handleOpenAcess = () => {
    setOpenAcess(true);
  };

  const saveOrEdit = async () => {
    const id = regionais?.filter((item) => item.id === regionalSelect)[0]
      // @ts-ignore
      ?.codigo;
    try {
      await API_USERS.SaveOrEdit(
        isEdit,
        email || '',
        idUser,
        name || '',
        lastName || '',
        sigla || '',
        isAdmin,
        isMobile,
        id || '',
        typeAcess,
        phone,
        locais || [],
        enterprises || [],
        setIsEdit,
        clearState,
        unCheck,
        setIdUser,
        setOpenModal,
        setPhone,
        requestPlaces,
        isPlace,
        isSpecialista,
        setLoadingSave,
        isVisit,
        requestUsers,
        corretor?.corretor?.value,
      );
    } catch (error: any) {
      //
    }
  };

  const updateStatusUser = async (id: string, status: boolean) => {
    try {
      await API_USERS.UpdatePlace(id, status, setData, data);
    } catch (error: any) {
      toast.error(
        `⚠ ${error?.data?.notifications?.map(
          (item: any) => `${item.message}\n`,
        )}`,
      );
    }
  };

  const checkPlace = (locaisFromUser: Array<{ idLocal: string }>) => {
    setLocais(
      locais?.map((item) => {
        locaisFromUser.map((it: { idLocal: string }) => {
          if (item.idLocal === it.idLocal) {
            item.check = true;
            return item;
          }
          return item;
        });
        return item;
      }),
    );
  };

  const checkEnteprise = (
    enterpriseUser: Array<{ idEmpreendimento: string }>,
  ) => {
    setEnterprises(
      enterprises?.map((item) => {
        enterpriseUser.map((it: { idEmpreendimento: string }) => {
          if (item.idEmpreendimento === it.idEmpreendimento) {
            item.check = true;
            return item;
          }
          return item;
        });
        return item;
      }),
    );
  };

  const unCheck = () => {
    setLocais(
      locais?.map((item) => {
        item.check = false;
        return item;
      }),
    );
    setEnterprises(
      enterprises?.map((item) => {
        item.check = false;
        return item;
      }),
    );
  };

  const checkPlaceToUser = (id: String) => {
    setLocais(
      locais?.map((item) => {
        if (item.idLocal === id) {
          item.check = !item.check;
          return item;
        }
        return item;
      }),
    );
  };

  const checkEnterprise = (id: String) => {
    setEnterprises(
      enterprises?.map((item) => {
        if (item.idEmpreendimento === id) {
          item.check = !item.check;
          return item;
        }
        return item;
      }),
    );
  };

  const checkAllEnterprise = () => {
    setEnterprises(
      enterprises?.map((item) => {
        item.check = true;
        return item;
      }),
    );
  };

  const checkAllPlaceToUser = () => {
    setLocais(
      locais?.map((item) => {
        item.check = true;
        return item;
      }),
    );
  };

  const prepareToEdit = async (item: UserPlatform) => {
    if (item.locais.length > 0 && item.nomePerfilAcesso === 'Admin') {
      checkPlace(item.locais);
    } else {
      checkEnteprise(item.empreendimentos);
    }

    const nome = item.nome.split(' ');
    setPhone(item.celular);
    setName(nome[0]);
    setemail(item.email);
    setIsAdmin(item.acessoAdmin);

    const lastNames = item?.nome?.split(' ');
    const sobrenome = lastNames?.filter((it, index) => index !== 0)?.join(' ');

    setLastName(sobrenome);
    setIsMobile(item.acessoMobile);
    setSigla(item.siglaNome);
    setRegionalSelect(item.idRegional);
    setTypeAcessName(item.nomePerfilAcesso);
    setTypeAcess(item.idPerfilAcesso);
    setIdUser(item.id);
    setOpenModal(true);
    setIsEdit(true);
    setIsVisit(false);
    setReceiverVisit(false);
    item.permissoes.map((element: { chave: string }) => {
      if (element.chave === 'tela_acompanhar_visita_especialista') {
        setIsVisit(true);
        setReceiverVisit(true);
      }
      return element;
    });
    // @ts-ignore
    if (item.idCorretor) requestCorretorById(item.idRegional, item.idCorretor);
  };

  function ListPlace() {
    return (
      <>
        {localUser?.map((item: any) => {
          const labelId = `checkbox-list-secondary-label-${item.idLocal}`;
          return (
            <ItemListModal
              key={item.idLocal}
              id={item.idLocal}
              imagem={item.urlImagem}
              nome={item.nome}
              labelId={labelId}
              check
            />
          );
        })}
      </>
    );
  }

  const applyFilter = (
    user: Array<{
      value: string;
      label: string;
    }>,
    typeAces: {
      value: string;
      label: string;
    },
  ) => {
    if (user.length > 0) {
      setData(dataCopy.filter((item) => item.id === user[0]?.value));
      return;
    }
    if (typeAces) {
      setData(
        dataCopy.filter((item) => item.idPerfilAcesso === typeAces?.value),
      );
    }
  };

  const newPlaceScreenChildren = () => (
    <>
      <div style={{ marginBottom: 6 }} />
      <InputCommon
        value={name || ''}
        onChange={setName}
        type="text"
        placeholder="Nome"
        isError={false}
        isDisabled={false}
      />
      <SizedBox />
      <InputCommon
        value={lastName || ''}
        onChange={setLastName}
        type="text"
        placeholder="Sobrenome"
        isError={false}
        isDisabled={false}
      />
      <SizedBox />
      <InputCommon
        value={email || ''}
        onChange={setemail}
        type="text"
        placeholder="E-mail"
        isError={false}
        isDisabled={false}
      />
      <SizedBox />
      <InputCommon
        value={phone}
        onChange={setPhone}
        type="text"
        placeholder="Celular"
        isError={false}
        isDisabled={false}
      >
        <InputMask mask="(99) 99999-9999" />
      </InputCommon>
      <SizedBox />

      <RowCheck>
        <SelectContainer>
          <SelectComponent
            isMultiple={false}
            data={profileAcess || []}
            open={openAcess}
            label="Tipo de usuário"
            onClose={handleCloseAcess}
            onOpen={handleOpenAcess}
            value={typeAcess}
            onChange={handleChangeAcess}
          />
        </SelectContainer>
        <SelectContainerRight>
          <div>
            <div style={{ fontFamily: 'Inter', color: color.grey9 }}>
              Plataforma
            </div>
            <Row style={{ marginTop: 6 }}>
              <LabelWithIcon onClick={() => setIsAdmin(!isAdmin)}>
                <div>WEB</div>
                <Img src={isAdmin ? icons.checkIcon : icons.unCheckIcon} />
              </LabelWithIcon>
              <LabelWithIcon onClick={() => setIsMobile(!isMobile)}>
                <div>APP</div>
                <Img src={isMobile ? icons.checkIcon : icons.unCheckIcon} />
              </LabelWithIcon>
            </Row>
          </div>
        </SelectContainerRight>
      </RowCheck>
      <SizedBox />
      <Row>
        <SelectComponent
          isMultiple={false}
          data={regionais || []}
          open={open}
          label="Regional"
          onClose={handleClose}
          onOpen={handleOpen}
          value={regionalSelect}
          onChange={handleChangeRegional}
        />
        <div style={{ width: 20 }} />
        <InputCommon
          value={sigla || ''}
          onChange={setSigla}
          type="text"
          placeholder="Sigla"
          isError={false}
          isDisabled={false}
        />
      </Row>
      <SizedBox />
      <SelectComponentAutoComplete
        isError={false}
        value={corretor?.corretor}
        label="Corretor *"
        helperText=""
        onChange={(ev: { label: string; value: string }) => {
          setCorretor({ corretor: ev });
        }}
        data={corretores.map((item) => ({
          label: item.nome,
          value: item.idCorretor,
        }))}
      />
      <br />
      {receiveVisit && (
        <RowCheckVisit
          onClick={() => {
            setIsVisit(!isVisit);
          }}
        >
          {isVisit ? (
            <Img src={icons.checkIcon} />
          ) : (
            <Img src={icons.unCheckIcon} />
          )}
          <div>Recebe solicitação de visistas</div>
        </RowCheckVisit>
      )}
      {isLabel && (
        <>
          <div style={{ fontFamily: 'Inter' }}>
            {isSpecialista ? 'Especialidade' : 'Local'}
          </div>
          <br />
          <ItemListModal
            id="void"
            nome="Selecionar todos"
            labelId="void"
            isBlue
            action={() => {
              if (isSpecialista) {
                checkAllEnterprise();
              } else {
                checkAllPlaceToUser();
              }
            }}
            check
          />
        </>
      )}
      {isSpecialista
        ? enterprises.map((item: InterPrise) => (
          <ItemListModal
            id={item.idEmpreendimento}
            imagem={item.urlImagem}
            nome={item.nome}
            labelId={item.idEmpreendimento}
            check={item.check || false}
            action={() => {
              checkEnterprise(item.idEmpreendimento);
            }}
          />
        ))
        : null}
      {isPlace
        ? locais?.map((item: any) => {
          const labelId = `checkbox-list-secondary-label-${item.idLocal}`;
          return (
            <ItemListModal
              key={item.idLocal}
              id={item.idLocal}
              imagem={item.urlImagem}
              nome={item.nome}
              labelId={labelId}
              check={item.check || false}
              action={() => {
                checkPlaceToUser(item.idLocal);
              }}
            />
          );
        })
        : null}
    </>
  );

  return (
    <>
      <NavCommon
        breadcrumbs={[{ path: '', name: 'Usuários' }]}
        hasOnChange
        onBack={() => {
          history.goBack();
        }}
        onChange={() => {
          if (permissoes?.includes('admin_recurso_cadastro_usuario')) {
            setOpenModal(true);
          }
        }}
      />
      <div>
        <TableCommon
          onSave={(first: any, second: any) => {
            applyFilter(first, second);
          }}
          hasFilter
          enterPriseData={dataCopy.map((item) => ({
            label: item.nome,
            value: item.id,
          }))}
          autoComplete
          onClean={() => setData(dataCopy)}
          setSecondSelect={() => {}}
          setFirstSelect={() => {}}
          isLoading={loading}
          activeEnterprise={() => {}}
          inactiveEnterprise={() => {}}
          onEdit={prepareToEdit}
          activeOrIncactiveLocal={updateStatusUser}
          isEnterprise
          title="Usuários"
          titleFirstSelect="Usuário"
          titleSecondSelect="Tipo de usuário"
          isSpecialist={false}
          data={data}
          isSigla
          isRegional
          isUser
          isPlaceIcon
          isMultiple={false}
          selectData={profileAcess.map((item) => ({
            label: item.nome,
            value: item.idPerfilAcesso,
          }))}
          openPlace={(event: any) => {
            if (event.locais.length === 0) {
              toast.info('Sem locais para este usuário');
              return;
            }
            setLocalUser(event.locais);
            setOpenLocal(true);
          }}
        />
        <DialogCommon
          open={openLocal}
          setOpenModal={setOpenLocal}
          component={ListPlace()}
          isFilter={false}
          saveText="FECHAR"
          title="Locais"
          isRight={false}
          onClose={() => {
            setOpenLocal(false);
            unCheck();
          }}
          onSave={() => {
            setOpenLocal(false);
          }}
          closeText=""
        />
        <DialogCommon
          open={openModal}
          loading={loadingSave}
          setOpenModal={setOpenModal}
          component={newPlaceScreenChildren()}
          isFilter={false}
          saveText="SALVAR"
          title={isEdit ? 'Edição de usuário' : 'Novo usuário'}
          isRight={false}
          isClose
          onClose={() => {
            unCheck();
            setOpenModal(false);
            clearState();
          }}
          onSave={() => {
            saveOrEdit();
          }}
          closeText="FECHAR"
        />
      </div>
    </>
  );
}
export default AddUser;
